import Lenis from "lenis";

let lenisInstance = null;

export function getLenis() {
  if (!lenisInstance && typeof window !== "undefined") {
    lenisInstance = new Lenis({ lerp: 0.1, duration: 1.2, smoothWheel: true });
  }
  return lenisInstance;
}

export function startLenisRaf() {
  const lenis = getLenis();
  if (!lenis) return () => {};
  let frameId;
  const raf = (time) => {
    lenis.raf(time);
    frameId = requestAnimationFrame(raf);
  };
  frameId = requestAnimationFrame(raf);
  return () => cancelAnimationFrame(frameId);
}

export function smoothScrollTo(href, offset = -90) {
  const target = document.querySelector(href);
  if (!target) return;
  const lenis = getLenis();
  if (lenis) {
    lenis.scrollTo(target, { offset, duration: 1.2 });
  } else {
    target.scrollIntoView({ behavior: "smooth" });
  }
}
